<template>
  <div v-loading="dataLoading" id="information" class="app-content-wrapper">
    <div v-if="infoData.merchantNo" class="information-top">
      <div class="title-box">
        <span class="title-txt">{{ `${businessType}` === '0' && (`${infoData.status}` === '4') ? infoData.loginEmail :
          infoData.merchantName }}</span>
        <el-tag :type="`${infoData.status}` === '1' ? 'success' : 'danger'">
          {{ infoData.statusName }}
        </el-tag>
      </div>
      <div class="desc-box">
        <span class="desc-txt">{{ $t('message.account.merchantNo') }}:</span>
        <span class="desc-value">{{ infoData.merchantNo }}</span>
      </div>
    </div>
    <details-component :details-condition="detailCondition" :itemMaxLine="0">
    </details-component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { getMerchantAudit } from '@/api/common/user';
import DetailsComponent from '@/components/base-details/details.vue';
import AccountInfo from '@/views/account/information/api/account-info';

export default {
  name: 'AccountDetailsComponent',
  components: {
    DetailsComponent,
  },
  data() {
    return {
      ...AccountInfo,
      infoData: {},
      detailCondition: [],
      dataLoading: false,
      businessType: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    this.dataLoading = true;
    this.getAccountInfo().then(data => {
      this.dataLoading = false;
      let profile = {};
      if (data.profile) {
        profile = JSON.parse(data.profile);
        this.businessType = profile.businessType;
      }
      console.log('this.businessType', typeof this.businessType);
      let statusName = this.$t('message.status.activation');
      if (data.status !== '1') {
        statusName = this.$t('message.status.inactivated');
      }
      const info = { ...data, signType: profile.signType, statusName };
      const { jumioStatus } = this.$store.getters.app;
      // if (!jumioStatus) {
      //   console.log('jumioStatus走这了吗');
      //   getMerchantAudit().then(async res => {
      //     await this.$store.dispatch('app/setjumioStatus', res);
      //     console.log('jumioStatus走这了吗', res);
      //     jumioStatus = res;
      //   });
      // }
      console.log('jumioStatus', jumioStatus);
      this.infoData = info;
      this.detailCondition.push({
        topTitle: 'message.account.info',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_transaction.png'),
        listTemplate: [
          {
            titleBar: { title: 'message.account.merchantNo' },
            key: 'merchantNo',
          },
          {
            titleBar: { title: 'message.account.merchantName' },
            key: 'merchantName',
            textFunc: (data) => {
              if (`${profile.businessType}` === '0' && (`${info.status}` === '4')) {
                return '--';
              }
              return data.merchantName;
            },
          },
          {
            titleBar: { title: 'message.account.loginEmail' },
            key: 'merchantEmail',
          },
          {
            titleBar: { title: 'message.tableCommon.status' },
            key: 'statusName',
            type: 'tag',
            tagTypeFunc: (data) => (`${data.status}` === '1' ? 'success' : 'danger'),
          },
          {
            titleBar: { title: 'Secret Type' },
            key: 'signType',
          },
          {
            titleBar: { title: 'message.account.registrationTime' },
            key: 'createTime',
          },
          {
            titleBar: { title: 'Secret Key' },
            key: 'secretKey',
          },
          {
            titleBar: { title: 'message.jumio.infoTitle' },
            key: 'faceAuthFlag',
            textFunc: (data) => {
              if (data.faceAuthFlag === 0 && !jumioStatus) {
                return `<div class="face-auth-status">
                <span>${this.$t('message.user.jumioNotCompletedNoicon')}</span>
                <a href="javascript:void(0)" onclick="window.location.href='/account/supplement/jumio'" class="link" style="color:#503DF6;cursor:pointer;margin-left:8px;">
                  ${this.$t('message.user.fillInfo')} >
                </a>
              </div>`;
              } else if (jumioStatus && jumioStatus.approveStatus === 'waiting') {
                return `<div class="face-auth-status">
                <span>${this.$t('message.user.autoNotPendding')}</span>
                <a href="javascript:void(0)" onclick="window.location.href='/account/supplement/jumio?type=view'" class="link" style="color:#503DF6;cursor:pointer;margin-left:8px;">
                  ${this.$t('message.tableCommon.see')} >
                </a>
              </div>`;
              } else if (jumioStatus && jumioStatus.approveStatus === 'fail') {
                return `<div class="face-auth-status">
                <span>${this.$t('message.user.authNotFass')}</span>
                <a href="javascript:void(0)" onclick="window.location.href='/account/supplement/jumio'" class="link" style="color:#503DF6;cursor:pointer;margin-left:8px;">
                  ${this.$t('message.user.modifyInfo')} >
                </a>
              </div>`;
              } else if (jumioStatus && jumioStatus.approveStatus === 'pass' && data.faceAuthFlag === 1) {
                return `<div class="face-auth-status">
                <span>${this.$t('message.jumio.authPass')}</span>
              </div>`;
              }
              return '';
            },
          },
        ],
        data: info,
      });
    }).catch(() => {
      this.dataLoading = false;
    });
  },
  methods: {
    // onEditAccount() {
    //
    // },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/variables.scss';

#information {
  .information-top {
    margin-bottom: 20px;
    padding-top: 4px;

    .title-box {
      display: flex;
      align-items: center;
      margin-bottom: 9px;

      .title-txt {
        font-size: 30px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 41px;
        margin-right: 30px;
      }
    }

    .desc-box {
      .desc-txt {
        font-size: 14px;
        font-family: Avenir-Book, Avenir;
        font-weight: normal;
        color: rgba(0, 32, 63, 0.6);
        line-height: 30px;
        margin-right: 10px;
      }

      .desc-value {
        font-size: 14px;
        font-family: Avenir-Heavy, Avenir;
        font-weight: 800;
        color: $color-text-primary;
        line-height: 28px;
      }
    }
  }
}
</style>
